import BaseModalController from 'components/modal/js/controller/base-modal-controller';

export class MatchesModalController extends BaseModalController {
    constructor($mdDialog) {
        super($mdDialog);
    }
}

MatchesModalController.$inject = [
    '$mdDialog',
];
